import { Component, OnInit } from '@angular/core';
import { TemplateUpdateService } from '../../../services/template-update.service';

@Component({
  selector: 'progress-indicator-accessibility',
  templateUrl: './progress-indicator-accessibility.component.html',
  styleUrls: ['./progress-indicator-accessibility.component.sass']
})
export class ProgressIndicatorAccessibilityComponent implements OnInit {
  infoText = this.templateService.accessibilityInfoText;
  header = this.templateService.accessibilityHeader;

  constructor(private templateService: TemplateUpdateService) { }

  ngOnInit(): void {
  }

}
